<div class="talent-page-wrapper">
    <!-- Standardized Brand Header -->
    <header class="talent-header">
        <div class="logo-section">
            <ng-container *ngIf="logoUrl; else defaultLogo">
                <img [src]="logoUrl" alt="Company Logo"
                    style="max-height: 40px; max-width: 150px; object-fit: contain; margin-right: 10px;">
            </ng-container>
            <ng-template #defaultLogo>
                <div class="logo-icon">
                    <i class="bi bi-cpu-fill"></i>
                </div>
            </ng-template>
            <div class="logo-text">
                <h6>{{ organizationName || 'AI Interview Platform' }}</h6>
                <p>SYSTEM SETUP</p>
            </div>
        </div>
        <div class="secure-badge">
            <span class="dot"></span>
            Secure AI session
        </div>
    </header>

    <div class="test-page-wrapper">

        <div class="setup-container">
            <!-- Back Navigation -->
            <!-- <a (click)="handleBack()" class="back-link-top">
            <i class="bi bi-arrow-left"></i> Back
        </a> -->

            <!-- Title -->
            <div class="title-section">
                <h1>Camera & Microphone Test</h1>
                <p>Make sure everything works before you begin.</p>
            </div>
            <div class="row g-4">
                <!-- Left Column: Media Preview -->
                <div class="col-12 col-lg-7">
                    <div class="media-card">
                        <!-- Video Container -->
                        <div class="video-container">
                            <!-- Live Preview Badge -->
                            <div class="live-badge" *ngIf="cameraActive">
                                <span class="dot-green"></span> Live preview
                            </div>

                            <!-- Video Element -->
                            <video #video [hidden]="!cameraActive" class="video-element" autoplay playsinline
                                muted></video>

                            <!-- Fallback Placeholder -->
                            <div class="video-placeholder" *ngIf="!cameraActive"
                                style="transition: all 0.2s; text-align: center; padding: 2rem;">
                                <i class="bi bi-camera"
                                    [ngClass]="{'text-danger': cameraPermissionDenied || micPermissionDenied, 'text-success': permissionsGranted}"></i>
                                <p *ngIf="permissionsGranted">Camera & microphone access has been granted.</p>
                            </div>
                        </div>

                        <!-- Device Selectors -->
                        <div class="device-selectors">
                            <div class="selector-group">
                                <label><i class="bi bi-mic-fill"></i> MICROPHONE</label>
                                <select class="form-select custom-select" [(ngModel)]="selectedAudioDevice"
                                    (change)="changeAudioDevice($event)" [disabled]="isRequestingPermissions">
                                    <option *ngIf="audioDevices.length === 0" value="">Default - Built-in mic</option>
                                    <option *ngFor="let device of audioDevices; let i = index"
                                        [value]="device.deviceId">{{ device.label || 'Microphone ' + (i + 1) }}</option>
                                </select>
                            </div>
                            <div class="selector-group">
                                <label><i class="bi bi-camera-video"></i> CAMERA</label>
                                <select class="form-select custom-select" [(ngModel)]="selectedVideoDevice"
                                    (change)="changeVideoDevice($event)" [disabled]="isRequestingPermissions">
                                    <option *ngIf="videoDevices.length === 0" value="">Default - Built-in camera
                                    </option>
                                    <option *ngFor="let device of videoDevices; let i = index"
                                        [value]="device.deviceId">{{ device.label || 'Camera ' + (i + 1) }}</option>
                                </select>
                            </div>
                        </div>

                        <!-- Permission Request CTA Area -->
                        <div class="mic-test-area border-0 pb-0">
                            <button class="test-mic-btn w-100" (click)="requestPermissions()"
                                [disabled]="isRequestingPermissions || permissionsGranted"
                                [ngStyle]="{'background': permissionsGranted ? '#10B981' : (isRequestingPermissions ? '#EEF2FF' : '#4F46E5'), 'color': permissionsGranted ? 'white' : (isRequestingPermissions ? '#4F46E5' : 'white'), 'border-color': permissionsGranted ? '#10B981' : '#4F46E5'}">
                                <span *ngIf="!isRequestingPermissions && !permissionsGranted"><i
                                        class="bi bi-camera-video me-2"></i><i class="bi bi-mic me-2"></i> Allow Camera
                                    & Microphone</span>
                                <span *ngIf="isRequestingPermissions"><i
                                        class="spinner-border spinner-border-sm me-2"></i> Requesting...</span>
                                <span *ngIf="permissionsGranted"><i class="bi bi-check-circle me-2"></i> Camera &
                                    Microphone Connected</span>
                            </button>
                            <div class="text-danger mt-3 text-center" style="font-size: 0.85rem;"
                                *ngIf="permissionErrorMessage">
                                <i class="bi bi-exclamation-triangle-fill"></i> {{ permissionErrorMessage }}
                            </div>
                        </div>

                        <!-- Mic Volume Visualizer -->
                        <div class="mic-test-area pt-3" *ngIf="permissionsGranted && micActive">
                            <label
                                style="display: block; font-size: 0.6875rem; font-weight: 800; color: #94A3B8; text-transform: uppercase; letter-spacing: 0.05rem; margin-bottom: 0.5rem;">
                                <i class="bi bi-mic"></i> Microphone Level
                            </label>
                            <div class="volume-visualizer mt-0">
                                <div class="volume-bar-bg">
                                    <div class="volume-bar-fill" [style.width.%]="volume"></div>
                                </div>
                            </div>
                            <div *ngIf="!hasAudioBeenDetected" class="text-warning mt-2" style="font-size: 0.8rem;">
                                <i class="bi bi-info-circle"></i> Please say something to test your microphone...
                            </div>
                            <div *ngIf="hasAudioBeenDetected" class="text-success mt-2" style="font-size: 0.8rem;">
                                <i class="bi bi-check-circle"></i> Audio detected!
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Column: Status & Rules -->
                <div class="col-12 col-lg-5">
                    <!-- Device Status Card -->
                    <div class="status-card">
                        <h5 class="status-title">DEVICE STATUS</h5>

                        <div class="status-list">
                            <div class="status-item">
                                <div class="status-label">
                                    <i class="bi bi-camera"></i> Camera
                                </div>
                                <div class="status-badge-inline"
                                    [ngClass]="cameraActive ? 'ready' : (cameraPermissionDenied ? 'blocked' : 'pending')"
                                    [style.color]="!cameraActive && !cameraPermissionDenied ? '#94A3B8' : null">
                                    <i class="bi"
                                        [ngClass]="cameraActive ? 'bi-check-circle' : (cameraPermissionDenied ? 'bi-x-circle' : 'bi-hourglass')"></i>
                                    {{ cameraActive ? 'Ready' : (cameraPermissionDenied ? 'Denied' : 'Pending') }}
                                </div>
                            </div>

                            <div class="status-item">
                                <div class="status-label">
                                    <i class="bi bi-mic"></i> Microphone
                                </div>
                                <div class="status-badge-inline"
                                    [ngClass]="micActive ? (hasAudioBeenDetected ? 'ready' : 'pending') : (micPermissionDenied ? 'blocked' : 'pending')"
                                    [style.color]="!micActive && !micPermissionDenied ? '#94A3B8' : null">
                                    <i class="bi"
                                        [ngClass]="micActive ? (hasAudioBeenDetected ? 'bi-check-circle' : 'bi-hourglass') : (micPermissionDenied ? 'bi-x-circle' : 'bi-hourglass')"></i>
                                    {{ micActive ? (hasAudioBeenDetected ? 'Ready' : 'Testing...') : (micPermissionDenied ? 'Denied' : 'Pending') }}
                                </div>
                            </div>

                            <div class="status-item">
                                <div class="status-label">
                                    <i class="bi bi-volume-up"></i> Speaker
                                </div>
                                <div class="status-badge-inline ready">
                                    <i class="bi bi-check-circle"></i> Ready
                                </div>
                            </div>

                            <div class="status-item border-0">
                                <div class="status-label">
                                    <i class="bi bi-wifi"></i> Internet
                                </div>
                                <div class="status-badge-inline"
                                    [ngClass]="networkQuality === 'POOR' || networkQuality === 'CHECKING' ? 'blocked' : 'ready'">
                                    <i class="bi"
                                        [ngClass]="networkQuality === 'POOR' || networkQuality === 'CHECKING' ? 'bi-x-circle' : 'bi-check-circle'"></i>
                                    {{ networkQuality === 'CHECKING' ? 'Checking...' : networkQuality === 'POOR' ?
                                    'Poor' : 'Ready' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Rules Card -->
                    <div class="rules-card">
                        <h6><i class="bi bi-lightbulb"></i> Before you begin</h6>
                        <ul>
                            <li><i class="bi bi-person-video"></i> Ensure good lighting on your face</li>
                            <li><i class="bi bi-volume-mute"></i> Sit in a quiet environment</li>
                            <li><i class="bi bi-globe"></i> Stable internet connection required</li>
                            <li><i class="bi bi-display"></i> Full screen sharing is mandatory</li>
                        </ul>
                    </div>

                    <!-- Continue Action -->
                    <button (click)="startInterview()"
                        [disabled]="!permissionsGranted || !cameraActive || !micActive || !hasAudioBeenDetected || isLoading"
                        class="continue-btn"
                        [class.disabled]="!permissionsGranted || !cameraActive || !micActive || !hasAudioBeenDetected || isLoading">
                        <span *ngIf="isLoading"><i class="spinner-border spinner-border-sm me-2"></i> Starting...</span>
                        <span *ngIf="!isLoading">Continue <i class="bi bi-arrow-right"></i></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Premium Loader -->
<div *ngIf="isLoading" class="premium-loader-overlay">
    <div class="premium-spinner">
        <div class="spinner-ring"></div>
        <i class="bi bi-cpu-fill spinner-icon"></i>
    </div>
</div>